import React from "react";

function IllustrationCommissionDistribution() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 97 96">
      <path
        d="M78.808 55.396c0 10.44-4.205 19.867-11.021 26.683-6.816 6.815-16.242 11.02-26.683 11.02-10.44 0-19.867-4.205-26.682-11.02C7.606 75.263 3.4 65.837 3.4 55.396c0-10.441 4.206-19.867 11.021-26.683 6.816-6.816 16.242-11.021 26.683-11.021.87 0 1.45-.58 1.45-1.45s-.58-1.45-1.45-1.45C18.627 14.791.5 32.918.5 55.395.5 77.873 18.627 96 41.104 96 63.582 96 81.71 77.873 81.71 55.396c0-.87-.58-1.45-1.45-1.45s-1.45.725-1.45 1.45z"
        className="fill-secondary"
      />
      <path
        d="M50.965 0v45.68h45.68C96.5 20.592 76.053 0 50.965 0z"
        className="fill-secondary"
      />
      <path
        d="M80.258 53.946h-3.625c-.87 0-1.45.58-1.45 1.45s.58 1.45 1.45 1.45h3.625c.87 0 1.45-.58 1.45-1.45 0-.725-.58-1.45-1.45-1.45zM57.491 53.946h-6.38c-.87 0-1.45.58-1.45 1.45s.58 1.45 1.45 1.45h6.38c.87 0 1.45-.58 1.45-1.45 0-.725-.58-1.45-1.45-1.45zm12.761 0h-6.38c-.87 0-1.45.58-1.45 1.45s.58 1.45 1.45 1.45h6.38c.87 0 1.45-.58 1.45-1.45 0-.725-.58-1.45-1.45-1.45zM44.73 53.946h-2.175V51.77c0-.87-.58-1.45-1.45-1.45s-1.45.58-1.45 1.45v3.626c0 .435.144.725.434 1.015.29.29.58.435 1.015.435h3.626c.87 0 1.45-.58 1.45-1.45 0-.725-.58-1.305-1.45-1.45zM42.555 32.628v-6.38c0-.87-.58-1.45-1.45-1.45s-1.45.58-1.45 1.45v6.38c0 .87.58 1.45 1.45 1.45s1.45-.58 1.45-1.45zm0 12.762v-6.38c0-.871-.58-1.451-1.45-1.451s-1.45.58-1.45 1.45v6.38c0 .87.58 1.45 1.45 1.45s1.45-.58 1.45-1.45zM42.555 20.012v-3.625c0-.87-.58-1.45-1.45-1.45s-1.45.58-1.45 1.45v3.625c0 .87.58 1.45 1.45 1.45s1.45-.725 1.45-1.45z"
        className="fill-primary"
      />
    </svg>
  );
}

export default IllustrationCommissionDistribution;
